import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c9a272a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animation-overlay" }
const _hoisted_2 = ["src"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'smart-search-loading-animation',
  setup(__props) {

const lottieSrc = computed(() => {
  const meditateJyranianSrc = "/Lottie/jyranian-meditate-docs.json";
  const shopKeeperJyranianSrc = "/Lottie/shop-owner-loading.json";
  const randomNumber = Math.round(Math.random());
  return randomNumber > 0 ? meditateJyranianSrc : shopKeeperJyranianSrc;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("lottie-player", {
      autoplay: "",
      loop: "",
      src: lottieSrc.value,
      style: {"width":"400px","height":"400px"}
    }, null, 8, _hoisted_2)
  ]))
}
}

})